import React from 'react'
import config from 'isomorphic-config'
import PclnUcChatBot, {
  HandleMarkerResponse,
  localCache
} from '@pcln/uc-chat-bot'
import { v4 as uuidv4 } from 'uuid'
import useBootstrapData from '@/hooks/useBootstrapData'
import analytics from '@/shared-utils/analytics'
import { head, last } from 'ramda'
import { LOCATION_SEARCH_TYPE } from '@/types'
import getCityListComponent from './getCityListComponent'

const JSONOBJECT_CITIES = 'JSONOBJECT_CITIES'
const MODAL_ARIA_LABEL = 'Travel Bot Chat Dialog Modal'

export const handleMarkerResponse: HandleMarkerResponse = (
  err,
  marker,
  fullText
) => {
  try {
    if (err) {
      throw err
    }
    if (marker === JSONOBJECT_CITIES && fullText) {
      const [headString, ...restStrArr] = fullText.split('JSONEND')
      const splitResult = headString?.split('JSONOBJECT_CITIES')
      const citiesListString = last(splitResult)?.trim()
      const prefixString = head(splitResult)?.trim()
      const parsedResult = citiesListString ? JSON.parse(citiesListString) : {}

      if (!Array.isArray(parsedResult?.cities)) {
        throw Error('no cities list')
      }
      return {
        role: 'assistant',
        content: '',
        promptContent: fullText, // saved as prompt content for the chat mode
        messageContent: JSONOBJECT_CITIES, // used for display the CitiesList Component
        markerComponentProps: {
          // props for CitiesList component
          citiesList: parsedResult?.cities, // used for displaying the cities list
          postfixStr: restStrArr?.join('')?.trim(), // Text before the list
          prefixString // Text after the list
        }
      }
    }
  } catch (error) {
    const catchErrorMessage =
      error instanceof Error ? error.message : JSON.stringify(error)

    analytics.logError({
      message: `ChatBot - handle marker response error: ${catchErrorMessage}`
    })

    return {
      role: 'assistant',
      content: 'Network error, please retry.'
    }
  }
}

function TravelChatBotModal(props: {
  isChatBotDialogOpened: boolean
  onModalClose: () => void
  onLocationSelect: (item: LOCATION_SEARCH_TYPE) => void
}) {
  const { isChatBotDialogOpened, onModalClose, onLocationSelect } = props

  const markerComponents = {
    [JSONOBJECT_CITIES]: getCityListComponent(onLocationSelect)
  }

  const { isMobile, webstats } = useBootstrapData()

  const mobileHeaderValue = 'Y'
  const pclnModalProps = {
    width: '766px',
    height: '542px',
    fullScreen: false,
    verticalAlignment: 'middle'
  }

  return (
    <PclnUcChatBot
      onClose={onModalClose}
      modalAriaLabel={MODAL_ARIA_LABEL}
      markerComponents={markerComponents}
      handleMarkerResponse={handleMarkerResponse}
      isMobile={isMobile}
      fetchRequestOptions={{
        url: config.client.uc.chatbot,
        headers: {
          'x-request-from': 'homePageHotelSearch',
          'x-is-mobile': mobileHeaderValue,
          'x-model-version': '4'
        }
      }}
      isChatBoxOpened={isChatBotDialogOpened}
      cachedPrompts={localCache.getLocalPrompts()}
      cachedMessages={localCache.getLocalMessages()}
      setCachedPrompts={localCache.setLocalPrompts}
      setCachedMessages={localCache.setLocalMessages}
      pclnModalProps={pclnModalProps}
      submitChatMessagesPayload={{
        hotelPayload: {},
        productId: 5,
        rguid: `HOMEPAGE-${uuidv4()}`,
        cguid: webstats?.clientGUID,
        dateToday: new Date().toString()
      }}
    />
  )
}

export default TravelChatBotModal
